import { Link } from "react-router-dom";

const Nav = (props) => {
  const {
    isMobile,
    currentPage,
    setDrawerOpen,
    setDrawerMix,
  } = props;

  return (
    <>
      {/* <div className={`nav__logo`}></div> */}
              <Link
          to="/"
          className={`nav__logo`}
          onClick={() => {
            setDrawerOpen(false);
            setDrawerMix(null);
          }}
        >
        </Link>
      <nav className="nav__wrapper">
        <div className={`nav__highlight ${currentPage}`}></div>
        <svg width="100%" height="100%" className="nav__mask">
          <mask id="hole-mask" className="nav__hole">
            <rect x="0" y="0" width="200%" height="100%" fill="white" />
            <rect
              x="5"
              y="5"
              width={isMobile?"calc(25% - 10px)":"95"}
              height="30"
              rx="3"
              ry="3"
              fill="black"
            />
          </mask>
        </svg>
        <div className={`nav__item disabled`}></div>
        <Link
          to="/"
          className={`nav__item ${currentPage === "home" ? "disabled" : ""}`}
          onClick={() => {
            setDrawerOpen(false);
            setDrawerMix(null);
          }}
        >
          Latest
        </Link>
        {/* <Link
        to="/radio"
        className={`nav__item ${currentPage === "radio" ? "disabled" : ""}`}
        onClick={() => {
          setDrawerOpen(false);
          setDrawerMix(null);
        }}
      >
        Radio
      </Link> */}
        <Link
          to="/archive"
          className={`nav__item ${currentPage === "archive" ? "disabled" : ""}`}
          onClick={() => {
            setDrawerOpen(false);
            setDrawerMix(null);
          }}
        >
          Archive
        </Link>
                <Link
          to="/playlists"
          className={`nav__item ${
            currentPage === "playlists" ? "disabled" : ""
          }`}
          onClick={() => {
            setDrawerOpen(false);
            setDrawerMix(null);
          }}
        >
          Playlists
        </Link>
      </nav>
    </>
  );
};

export default Nav;
